var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.transaction.is_refund)?_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("Refund")]):(_vm.transaction.has_full_refund)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v(" Fully Refunded ")]):(_vm.transaction.has_partial_refund)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Partially Refunded")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }